import { Injectable } from '@angular/core';
import {
    HttpResponse,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from './loader-service.component';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { UserService } from '../user/user.service';
import { SharedService } from '../shared.service';
import { Router } from '@angular/router';
import { LoginService } from '../../shared-modules/login/login.service';
import { AppInsights } from 'applicationinsights-js';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

    public static TempExcludedURLs = [];
    public static ExcludedURLs = [
        'GetLoginDistrictSettings',
        'track',
        'json',
        'CheckBroadcast',
        'CheckNotifications',
        'DataQueryUpdateRecentQueries',
        'GetDataQueryNextPage',
        'GetGradebookV9StudentMarksByStudentId',
        'GetParentNotificationCount',
        'GetParentNotificationPage',
        'GetMassEmailLogCount',
        'GetMassEmailLogPage',
        'GetReportEmailNotificationPage',
        'GetReportEmailNotificationCount',
        'CheckClassAutoSchedulerBatch',
        'SaveGridTemplates',
        '/OneSISPortalMenuPreferences',
        '/OneSISFavorites',
        'ViewCollectionDocument',
        'ViewSpEdCollectionDocument',
        'PrintBlankCollection'
    ];
    public static ExcludedURLsV10 = [
        'GetBehaviorEvents',
        'GetBehaviorEventCount'
    ];
    public static IgnoreErrors = [
        'CheckBroadcast',
        'CheckNotifications'
    ];

    private requests: HttpRequest<any>[] = [];
    public errorDialogRef: MatDialogRef<ErrorDialogComponent>;

    constructor(
        private loaderService: LoaderService,
        private dialog: MatDialog,
        private userService: UserService,
        private sharedService: SharedService,
        private router: Router,
        private loginService: LoginService
    ) {

        // This is in case of weird timing errors
        setInterval(() => {
            this.loaderService.isLoading.next(this.requests.length > 0);
        }, 1000);
    }

    removeRequest(req: HttpRequest<any>) {
        const i = this.requests.indexOf(req);
        if (i >= 0) {
            this.requests.splice(i, 1);

        }
        this.loaderService.isLoading.next(this.requests.length > 0);
    }

    intercept(nextReq: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // prevent Edge from serving cached api calls
        let req = nextReq;
        if (nextReq.url.indexOf('/AppApi') >= 0) {
            req = req.clone({
                headers: req.headers.set('Cache-Control', 'no-cache')
                    .set('Pragma', 'no-cache')
                    .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
                    .set('If-Modified-Since', '0')
            });
        }

        if (!this.cardRetrieval(req.url)
            && !LoaderInterceptor.TempExcludedURLs.find(excludedURL => req.url.includes(excludedURL))
            && !LoaderInterceptor.ExcludedURLs.find(excludedURL => req.url.includes(excludedURL))
            && (!this.loginService.LoginSettings || !this.loginService.LoginSettings.V10 || !LoaderInterceptor.ExcludedURLsV10.find(excludedURL => req.url.includes(excludedURL)))
        ) {
            this.requests.push(req);
            this.loaderService.isLoading.next(true);
        }
        else {
            this.removeRequest(req);
        }
        return Observable.create(observer => {
            const subscription = next.handle(req)
                .subscribe(
                    event => {
                        if (event instanceof HttpResponse) {
                            this.removeRequest(req);
                            observer.next(event);
                        }
                    },
                    err => {
                        this.removeRequest(req);
                        observer.error(err);
                        if (!LoaderInterceptor.IgnoreErrors.find(ignoredURL => req.url.includes(ignoredURL))) {
                            if (err.error != undefined && err.error.Message == 'Authorization has been denied for this request.') {
                                this.dialog.closeAll();
                                this.router.navigate(['']);
                            }
                            if (err.error != undefined && err.error.Message == 'An error has occurred.' && !this.errorDialogRef) {
                                this.sharedService.updateShowSpinner(false);
                                if (this.userService.username != null || this.userService.username != '') {
                                    this.errorDialogRef = this.dialog.open(ErrorDialogComponent, {
                                        panelClass: 'tyl-mat-dialog',
                                        disableClose: true,
                                        data: {
                                            apiCall: req.url
                                        }
                                    });
                                    this.errorDialogRef.afterClosed().subscribe(data => {
                                        this.errorDialogRef = undefined;
                                    });
                                }
                            }
                        }
                    },
                    () => { this.removeRequest(req); observer.complete(); });
            // teardown logic in case of cancelled requests
            return () => {
                this.removeRequest(req);
                subscription.unsubscribe();
            };
        });
    }

    cardRetrieval(serviceName) {
        if (this.router.url == '/classroom360/cards') {
            if (serviceName.includes('GetMyClasses')) {
                return true;
            }
            else if (serviceName.includes('GetAbsenceByCourseCard')) {
                return true;
            }
            else if (serviceName.includes('GetSchoolsTodayCard')) {
                return true;
            }
            else if (serviceName.includes('GetRecentBehaviorCard')) {
                return true;
            }
            else if (serviceName.includes('getMyLinks')) {
                return true;
            }
            else if (serviceName.includes('GetProgramEnrollmentCard')) {
                return true;
            }
            else if (serviceName.includes('GetStaffTeamsCard')) {
                return true;
            }
            else if (serviceName.includes('GetStaffWorkCard')) {
                return true;
            }
            else if (serviceName.includes('GetEFormSurveysForStaffCard')) {
                return true;
            }
            return false;
        }
    }

}
